import {
  PRODUCT_SPECIFICATION,
  IMG_PLACEHOLDER,
} from '@components/utils/textVariables'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import SwiperCore, { Navigation, FreeMode } from 'swiper'
import { useUI } from '@components/ui'
import ProductSpecifications from './specifications'
import { useState } from 'react'
import { generateUri } from '@commerce/utils/uri-util'
import { ALLOWED_SLUG_FOR_TROOPOD, EmptyGuid, FirebaseKeys } from '@components/utils/constants'
import { GA_EVENT } from 'hooks/ga_event.modal'
import { recordGA4Event } from '@components/services/analytics/ga4'
import { groupBy } from '@framework/utils/lodash'
import { getRemoteConfigAsBoolean } from '@framework/utils/app-util'

SwiperCore.use([Navigation])

export default function ProductDetails({ product, deviceInfo }: any) {
  const attrGroup = groupBy(product?.customAttributes, 'key')
  const imageTagGroup = groupBy(product?.images, 'tag')
  const [isOpen, setIsOpen] = useState(false)
  const { user } = useUI()
  function openSpecification() {
    setIsOpen(true)
    recordGA4Event(window, GA_EVENT.SPECIFICATION_PRODUCT_DETAIL, {
      category_selected: product?.mappedCategories[2]?.categoryName,
      header: product?.name,
      current_page: window?.location?.href,
      loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
    })
  }
  const [paddingTop, setPaddingTop] = useState('0')
  const { isOnlyMobile , isDesktop } = deviceInfo
  const isTroopod = getRemoteConfigAsBoolean(FirebaseKeys.TROOPOD_ENABLED)
  return (
    <>
      <div className="flex flex-col sm:hidden">
        <div className="section-devider"></div>
      </div>
      <div className="grid grid-cols-1 px-4 pl-0 pr-0 mt-0 sm:mt-10 sm:grid-cols-2 gap-x-4 sm:px-0">
        <div className={`sm:col-span-1 ${isOnlyMobile ? 'pl-4 pr-4' : ''}`}>
          <div className="flex-1 pb-0 pr-4 sm:pb-4">
            <h2 className="mb-2 text-2xl font-bold text-dark-brown">
              {PRODUCT_SPECIFICATION}
            </h2>
            {product?.link && !isDesktop &&
              ALLOWED_SLUG_FOR_TROOPOD.includes(product?.link) && isTroopod && (
                <div
                  className="troo trooFeed mobileOnly"
                  data-productId={product?.recordId || product?.productId}
                  data-tag="primary"
                  data-title={PRODUCT_SPECIFICATION}
                  style={{ height: '490px' }}
                ></div>
            )}
            {attrGroup['product.keyreasonstobuy']?.length > 0 && (
              <div className="pb-2 mb-1 border-b border-gray-200 sm:pb-3 sm:mb-3">
                <div className="flex flex-wrap ul-li-disc">
                  {attrGroup['product.keyreasonstobuy'].map(
                    (detail: any, cdx: number) => (
                      <div
                        key={`product-${cdx}-detil-value`}
                        className="text-sm font-normal leading-7 text-brown"
                        dangerouslySetInnerHTML={{
                          __html: detail.value || detail.value,
                        }}
                      />
                    )
                  )}
                </div>
              </div>
            )}
          </div>
          <div className="hidden sm:block">
            <ProductSpecifications
              attrGroup={attrGroup}
              product={product}
              deviceInfo={deviceInfo}
            />
          </div>
        </div>
        {imageTagGroup?.specification?.length && (
          <div className="my-6 sm:col-span-1 specifications sm:my-0">
            <Swiper
              slidesPerView={1.3}
              spaceBetween={8}
              navigation={true}
              loop={false}
              freeMode={true}
              modules={[FreeMode]}
              breakpoints={{
                640: {
                  slidesPerView: 1.3,
                },
                768: {
                  slidesPerView: 1.3,
                },
                1024: {
                  slidesPerView: 1.3,
                },
              }}
            >
              <div
                role="list"
                className="inline-flex mx-4 space-x-0 sm:mx-0 lg:mx-0 lg:space-x-0 lg:grid lg:grid-cols-4 lg:gap-x-0"
              >
                {imageTagGroup?.specification?.map((img: any, iid: number) => {
                  const imageUrl =
                    generateUri(img?.image, 'h=675') || IMG_PLACEHOLDER
                  return (
                    <SwiperSlide
                      className={`px-0 ${
                        iid === 0 && isOnlyMobile ? 'cs-mr-1' : ''
                      } `}
                      key={`product-${iid}-swiper-detil`}
                    >
                      <div className="image-container" style={{ paddingTop }}>
                        <img
                          onLoad={({ target }) => {
                            const { naturalWidth, naturalHeight } =
                              target as HTMLImageElement
                            setPaddingTop(`0`)
                          }}
                          src={imageUrl}
                          alt={img.name}
                          className="image"
                        />
                      </div>
                    </SwiperSlide>
                  )
                })}
              </div>
            </Swiper>
          </div>
        )}
        <div className="block sm:hidden">
          {isOpen ? (
            <>
              <div
                className={`flex flex-col pt-3 mb-3 ${
                  isOnlyMobile ? 'pl-4 pr-4' : ''
                }`}
              >
                <button
                  type="button"
                  className="text-sm font-semibold text-left text-orange-500"
                  onClick={() => setIsOpen(false)}
                >
                  Hide Product Details
                  <span className="ml-1">
                    <i className="rotate-180 sprite-icon sprite-down-orange-arrow" />
                  </span>
                </button>
              </div>
              <ProductSpecifications
                attrGroup={attrGroup}
                product={product}
                deviceInfo={deviceInfo}
              />
            </>
          ) : (
            <>
              <div
                className={`flex flex-col pt-3 ${
                  isOnlyMobile ? 'pl-4 pr-4' : ''
                }`}
              >
                <button
                  type="button"
                  className="text-sm font-semibold text-left text-orange-500"
                  onClick={() => openSpecification()}
                >
                  View Product Details
                  <span className="ml-1">
                    <i className="sprite-icon sprite-down-orange-arrow" />
                  </span>
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}
